import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Search } from 'lucide-react';
import { motion } from 'framer-motion';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="bg-[#FDFEFA] min-h-screen flex items-center" data-testid="notfound-page">
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 lg:px-16 py-24 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center w-full">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-[#83BF42] text-xs uppercase tracking-[0.25em] font-['Inter'] mb-4"
          >
            404 — Page not found
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="text-[#242326] text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight font-['Inter']"
          >
            That page is off-grid.
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="text-[#4A4A48] text-base md:text-lg font-['Lato'] font-light leading-relaxed mt-5 max-w-xl"
          >
            The link you followed is broken, retired, or wandered off the sitemap. Try one of the routes below — or jump straight to our latest thinking.
          </motion.p>
          <div className="mt-8 flex flex-wrap gap-3">
            <button
              onClick={() => navigate('/')}
              data-testid="notfound-home"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#242326] text-white text-sm font-['Inter'] hover:bg-[#1a1a1d] transition-all duration-300 group"
            >
              Back home
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => navigate('/insights')}
              data-testid="notfound-insights"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#242326]/15 text-[#242326] text-sm font-['Inter'] hover:bg-[#242326]/5 transition"
            >
              Read insights
            </button>
            <button
              onClick={() => navigate('/work')}
              data-testid="notfound-work"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#242326]/15 text-[#242326] text-sm font-['Inter'] hover:bg-[#242326]/5 transition"
            >
              See our work
            </button>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="relative aspect-square max-w-md mx-auto md:ml-auto md:mr-0 w-full"
        >
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-[#83BF42]/30 via-[#83BF42]/10 to-transparent blur-2xl" />
          <div className="relative h-full flex items-center justify-center rounded-3xl bg-[#242326] overflow-hidden border border-[#242326]/10">
            <span className="text-white text-[180px] md:text-[220px] font-light font-['Inter'] leading-none tracking-tight select-none">
              404
            </span>
            <Search className="absolute bottom-6 right-6 w-8 h-8 text-[#83BF42]/60" />
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
